import React from 'react';
import PhenoScanSubTab, { StatCard } from './PhenoScanSubTab';

export default function Panicle() {
  return (
    <PhenoScanSubTab
      testIdPrefix="panicle"
      analyzeEndpoint="/phenoscan/panicle/analyze"
      sampleEndpoint="/phenoscan/panicle/sample"
      sampleMetaEndpoint="/phenoscan/panicle/sample-meta"
      exportKey="panicle"
      title="Panicle / Spike"
      gtFormField="ground_truth_length_cm"
      renderResult={renderResult}
      traitExtractor={(r) => r ? ({
        source: 'phenoscan_panicle',
        traits: {
          length_cm: r.length_cm, width_cm: r.width_cm, area_cm2: r.area_cm2,
          compactness_index: r.compactness_index,
          spikelet_count: r.spikelet_count_estimate,
          branch_count: r.branch_count_estimate,
          spikelet_density_per_cm: r.spikelet_density_per_cm,
        },
      }) : null}
    />
  );
}

function renderResult(r) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <StatCard title="Dimensions" rows={[
        ['Length (cm)', r.length_cm], ['Width (cm)', r.width_cm],
        ['Area (cm²)', r.area_cm2], ['Compactness index', r.compactness_index],
        ['Length (px)', r.length_px], ['Width (px)', r.width_px],
      ]} />
      <StatCard title="Counts" rows={[
        ['Spikelet count (estimate)', r.spikelet_count_estimate],
        ['Branch count (estimate)', r.branch_count_estimate],
        ['Spikelet density (per cm)', r.spikelet_density_per_cm],
      ]} />
      <StatCard title="Method" rows={Object.entries(r.method || {})} />
    </div>
  );
}
